import axios from 'axios'

export const passCurrentLanguage = (language: string | undefined) => {
  if (language) axios.defaults.headers.common.language = language
}

export const getCurrentLanguageHeader = () => axios.defaults.headers.common.language
